<div class="row">
  <div class="col-md-12">
    <button class="float-right" mat-flat-button mat-stroked-button (click)="CreateNewLoan()">
      Add New Loan Scenario
    </button>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12 table-responsive">
    <table class="mtable">
      <tr>
        <td class="p-0 table-scroll">
          <table class="border1 ref-head">
            <tr>
              <th><div class="m-head sm-wdh">&nbsp;</div></th>
            </tr>
            <tr>
              <td>Total Loan Balance</td>
            </tr>
            <tr>
              <td>Maximum Term</td>
            </tr>
            <tr>
              <td>Interest Rate</td>
            </tr>
            <tr>
              <td>Expected Closing Costs</td>
            </tr>
            <tr>
              <td>Total Monthly Payment</td>
            </tr>
            <tr>
              <td>Time until Payoff</td>
            </tr>
            <tr>
              <td>Change in Monthly Payment</td>
            </tr>
            <tr>
              <td>Change in Monthly Interest</td>
            </tr>
            <tr>
              <td>Total interest saved</td>
            </tr>
            <tr>
              <td>Time to break even</td>
            </tr>
            <!-- <tr>
              <td><div>&nbsp;</div></td>
            </tr> -->
          </table>
        </td>
        <td class="p-0">
          <app-refinance-mortgage-scenario
            [principalBalance]="mortgage?.principalBalance"
            [termBalance]="mortgage?.termBalance"
            [interestRate]="mortgage?.interest"
            [term]="mortgage?.term"
            [isCurrentMortgage]="true"
            [isActive]="current"
            [computedLoan]="computedLoan"
            (changeInLoanValue)="selectedChange($event, true)"
            [heading]="'Current Loan'"
          ></app-refinance-mortgage-scenario>
        </td>

        <td class="p-0" *ngFor="let loanMortgage of mortgage?.refinanceScenarioList; let i = index">
          <app-refinance-mortgage-scenario
            [principalBalance]="mortgage?.principalBalance"
            [termBalance]="loanMortgage?.termBalance"
            [interestRate]="loanMortgage?.interestRate"
            [closingCost]="loanMortgage?.closingCost"
            [isCurrentMortgage]="false"
            [isActive]="loanMortgage?.isActive"
            [computedLoan]="computedLoan"
            [heading]="loanMortgage?.name"
            [loanId]="loanMortgage?.id"
            (changeInLoanValue)="selectedChange($event, false)"
            [isDelete]="deleteLoan"
          ></app-refinance-mortgage-scenario>
        </td>
      </tr>
    </table>
  </div>
</div>
